import template from './location.create.html';
import controller from './location.create.controller';
import './location.create.controller';
import './location.create.scss'
let locationcreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '=',

    // these bindings will be used when this template is used in modal in shipment_batch
    model: '=',
    success: '=',
    error: '='
  },
  template,
  controller
};

export default locationcreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/create/location.create.component.js